"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OCCUPIED_TABLE_EVENTS = void 0;
const domain_1 = require("@oolio-group/domain");
const initiateOrder_1 = __importDefault(require("./initiateOrder"));
const saveOrder_1 = __importDefault(require("./saveOrder"));
const holdOrder_1 = __importDefault(require("./holdOrder"));
const assignTable_1 = __importDefault(require("./assignTable"));
const assignTables_1 = __importDefault(require("./assignTables"));
const assignCustomer_1 = __importDefault(require("./assignCustomer"));
const unassignCustomer_1 = __importDefault(require("./unassignCustomer"));
const assignStaff_1 = __importDefault(require("./assignStaff"));
const orderPayment_1 = __importDefault(require("./orderPayment"));
const updateOrderNotes_1 = __importDefault(require("./updateOrderNotes"));
const voidOrder_1 = __importDefault(require("./voidOrder"));
const addOrderItem_1 = __importDefault(require("./addOrderItem"));
const updateOrderItemQuantity_1 = __importDefault(require("./updateOrderItemQuantity"));
const addModifier_1 = __importDefault(require("./addModifier"));
const removeModifier_1 = __importDefault(require("./removeModifier"));
const updateModifierQuantity_1 = __importDefault(require("./updateModifierQuantity"));
const updateOrderItemPrice_1 = __importDefault(require("./updateOrderItemPrice"));
const removeOrderItem_1 = __importDefault(require("./removeOrderItem"));
const assignOrderType_1 = __importDefault(require("./assignOrderType"));
const addOrderItemNotes_1 = __importDefault(require("./addOrderItemNotes"));
const addDiscount_1 = __importDefault(require("./addDiscount"));
const addTip_1 = __importDefault(require("./addTip"));
const updateTip_1 = __importDefault(require("./updateTip"));
const addAdjustments_1 = __importDefault(require("./addAdjustments"));
const removeAdjustments_1 = __importDefault(require("./removeAdjustments"));
const initiateRefund_1 = __importDefault(require("./initiateRefund"));
const printOrder_1 = __importDefault(require("./printOrder"));
const tableCheck_1 = __importDefault(require("./tableCheck"));
const initiateOnlineOrder_1 = __importDefault(require("./initiateOnlineOrder"));
const fireOrderItems_1 = __importDefault(require("./fireOrderItems"));
const refundOrderItems_1 = __importDefault(require("./refundOrderItems"));
const assignRefundReason_1 = __importDefault(require("./assignRefundReason"));
const kitchenPrint_1 = __importDefault(require("./kitchenPrint"));
const updateSeatNumber_1 = __importDefault(require("./updateSeatNumber"));
const acceptOrder_1 = __importDefault(require("./acceptOrder"));
const rejectOrder_1 = __importDefault(require("./rejectOrder"));
const partnerCancelOrder_1 = __importDefault(require("./partnerCancelOrder"));
const completeOrder_1 = __importDefault(require("./completeOrder"));
const switchCourseItem_1 = __importDefault(require("./switchCourseItem"));
const updateLastCheck_1 = __importDefault(require("./updateLastCheck"));
const orderPlaced_1 = __importDefault(require("./orderPlaced"));
const updateFulfilmentDetail_1 = __importDefault(require("./updateFulfilmentDetail"));
const paymentProcessed_1 = __importDefault(require("./paymentProcessed"));
const initiateMerge_1 = __importDefault(require("./initiateMerge"));
const orderMerged_1 = __importDefault(require("./orderMerged"));
const addRewardItem_1 = __importDefault(require("./addRewardItem"));
const updateRewardItem_1 = __importDefault(require("./updateRewardItem"));
const removeRewardItem_1 = __importDefault(require("./removeRewardItem"));
const resetRewards_1 = __importDefault(require("./resetRewards"));
const addOrderLoyaltySnapshot_1 = __importDefault(require("./addOrderLoyaltySnapshot"));
const updateCustomerInfo_1 = __importDefault(require("./updateCustomerInfo"));
const unassignTable_1 = __importDefault(require("./unassignTable"));
const updateAdjustments_1 = __importDefault(require("./updateAdjustments"));
const assignOrderName_1 = __importDefault(require("./assignOrderName"));
const noopEvent_1 = __importDefault(require("./noopEvent"));
const removeOrderHold_1 = __importDefault(require("./removeOrderHold"));
const splitQuantityOrderItem_1 = __importDefault(require("./splitQuantityOrderItem"));
const refundOrderAmount_1 = __importDefault(require("./refundOrderAmount"));
const setOrderAllergens_1 = __importDefault(require("./setOrderAllergens"));
const refundOrderUpdate_1 = __importDefault(require("./refundOrderUpdate"));
const updateOrderItemsAdjustment_1 = __importDefault(require("./updateOrderItemsAdjustment"));
const assignReservation_1 = __importDefault(require("./assignReservation"));
const addComboProduct_1 = __importDefault(require("./addComboProduct"));
const transferItems_1 = __importDefault(require("./transferItems"));
const transferredItems_1 = __importDefault(require("./transferredItems"));
const transferTables_1 = __importDefault(require("./transferTables"));
const unassignReservation_1 = __importDefault(require("./unassignReservation"));
const orderLock_1 = __importDefault(require("./orderLock"));
const orderUnlock_1 = __importDefault(require("./orderUnlock"));
const eventHandlerMap = {
    [domain_1.OrderAction.ORDER_INITIATE]: initiateOrder_1.default,
    [domain_1.OrderAction.ORDER_SAVE]: saveOrder_1.default,
    [domain_1.OrderAction.ORDER_VOID]: voidOrder_1.default,
    [domain_1.OrderAction.ORDER_HOLD]: holdOrder_1.default,
    [domain_1.OrderAction.ORDER_ASSIGN_TABLE]: assignTable_1.default,
    [domain_1.OrderAction.ORDER_ASSIGN_TABLES]: assignTables_1.default,
    [domain_1.OrderAction.ORDER_ASSIGN_CUSTOMER]: assignCustomer_1.default,
    [domain_1.OrderAction.ORDER_UPDATE_CUSTOMER]: updateCustomerInfo_1.default,
    [domain_1.OrderAction.ORDER_UNASSIGN_CUSTOMER]: unassignCustomer_1.default,
    [domain_1.OrderAction.ORDER_UNASSIGN_TABLE]: unassignTable_1.default,
    [domain_1.OrderAction.ORDER_ASSIGN_NAME]: assignOrderName_1.default,
    [domain_1.OrderAction.ORDER_ASSIGN_STAFF]: assignStaff_1.default,
    [domain_1.OrderAction.ORDER_ASSIGN_ORDER_TYPE]: assignOrderType_1.default,
    [domain_1.OrderAction.ORDER_PAYMENT]: orderPayment_1.default,
    [domain_1.OrderAction.ORDER_PAYMENT_PROCESSED]: paymentProcessed_1.default,
    [domain_1.OrderAction.ORDER_UPDATE_ORDER_NOTES]: updateOrderNotes_1.default,
    [domain_1.OrderAction.ORDER_UPDATE_FULFILMENT_DETAIL]: updateFulfilmentDetail_1.default,
    [domain_1.OrderAction.ORDER_ITEM_ADD]: addOrderItem_1.default,
    [domain_1.OrderAction.ORDER_ITEM_ADD_COMBO]: addComboProduct_1.default,
    [domain_1.OrderAction.ORDER_ITEM_REMOVE]: removeOrderItem_1.default,
    [domain_1.OrderAction.ORDER_ITEM_ADD_MODIFIER]: addModifier_1.default,
    [domain_1.OrderAction.ORDER_ITEM_REMOVE_MODIFIER]: removeModifier_1.default,
    [domain_1.OrderAction.ORDER_ITEM_UPDATE_QUANTITY]: updateOrderItemQuantity_1.default,
    [domain_1.OrderAction.ORDER_ITEM_ADD_NOTES]: addOrderItemNotes_1.default,
    [domain_1.OrderAction.ORDER_ITEM_UPDATE_MODIFIER_QUANTITY]: updateModifierQuantity_1.default,
    [domain_1.OrderAction.ORDER_ITEM_UPDATE_PRICE]: updateOrderItemPrice_1.default,
    [domain_1.OrderAction.ORDER_SET_ALLERGENS]: setOrderAllergens_1.default,
    [domain_1.OrderAction.ORDER_ADD_DISCOUNT]: addDiscount_1.default,
    [domain_1.OrderAction.ORDER_ASSIGN_RESERVATION]: assignReservation_1.default,
    [domain_1.OrderAction.ORDER_UNASSIGN_RESERVATION]: unassignReservation_1.default,
    [domain_1.OrderAction.ORDER_ADD_TIP]: addTip_1.default,
    [domain_1.OrderAction.ORDER_UPDATE_TIP]: updateTip_1.default,
    [domain_1.OrderAction.ORDER_ADD_ADJUSTMENT]: addAdjustments_1.default,
    [domain_1.OrderAction.ORDER_REMOVE_ADJUSTMENTS]: removeAdjustments_1.default,
    [domain_1.OrderAction.ORDER_REFUND_INITIATE]: initiateRefund_1.default,
    [domain_1.OrderAction.ORDER_ASSIGN_REFUND_REASON]: assignRefundReason_1.default,
    [domain_1.OrderAction.ORDER_REFUND_ITEMS]: refundOrderItems_1.default,
    [domain_1.OrderAction.ORDER_REFUND_AMOUNT]: refundOrderAmount_1.default,
    [domain_1.OrderAction.ORDER_REFUND_UPDATE]: refundOrderUpdate_1.default,
    [domain_1.OrderAction.ORDER_PRINT]: printOrder_1.default,
    [domain_1.OrderAction.ORDER_TABLE_CHECK]: tableCheck_1.default,
    [domain_1.OrderAction.ORDER_INITIATE_ONLINE]: initiateOnlineOrder_1.default,
    [domain_1.OrderAction.ORDER_FIRE_ITEMS]: fireOrderItems_1.default,
    [domain_1.OrderAction.ORDER_PRINT_KITCHEN_DOCKET]: kitchenPrint_1.default,
    [domain_1.OrderAction.ORDER_UPDATE_SEAT_NUMBER]: updateSeatNumber_1.default,
    [domain_1.OrderAction.ORDER_ACCEPT]: acceptOrder_1.default,
    [domain_1.OrderAction.ORDER_REJECT]: rejectOrder_1.default,
    [domain_1.OrderAction.ORDER_PARTNER_CANCEL]: partnerCancelOrder_1.default,
    [domain_1.OrderAction.ORDER_COMPLETE]: completeOrder_1.default,
    [domain_1.OrderAction.ORDER_SWITCH_COURSE_ITEM]: switchCourseItem_1.default,
    [domain_1.OrderAction.ORDER_UPDATE_LAST_CHECK]: updateLastCheck_1.default,
    [domain_1.OrderAction.ORDER_PLACED]: orderPlaced_1.default,
    [domain_1.OrderAction.ORDER_INITIATE_MERGE]: initiateMerge_1.default,
    [domain_1.OrderAction.ORDER_MERGED]: orderMerged_1.default,
    [domain_1.OrderAction.ORDER_REWARD_ADD]: addRewardItem_1.default,
    [domain_1.OrderAction.ORDER_REWARD_UPDATE_QUANTITY]: updateRewardItem_1.default,
    [domain_1.OrderAction.ORDER_REWARD_REMOVE]: removeRewardItem_1.default,
    [domain_1.OrderAction.ORDER_REWARD_RESET]: resetRewards_1.default,
    [domain_1.OrderAction.ORDER_REWARD_ADD_SNAPSHOT]: addOrderLoyaltySnapshot_1.default,
    [domain_1.OrderAction.ORDER_UPDATE_ADJUSTMENTS]: updateAdjustments_1.default,
    [domain_1.OrderAction.ORDER_ITEMS_UPDATE_ADJUSTMENT]: updateOrderItemsAdjustment_1.default,
    [domain_1.OrderAction.ORDER_OPEN]: noopEvent_1.default,
    [domain_1.OrderAction.ORDER_CLOSE]: noopEvent_1.default,
    [domain_1.OrderAction.CUSTOMER_NOTIFICATION]: noopEvent_1.default,
    [domain_1.OrderAction.REMOVE_ORDER_HOLD]: removeOrderHold_1.default,
    [domain_1.OrderAction.ORDER_ITEM_SPLIT_QUANTITY]: splitQuantityOrderItem_1.default,
    [domain_1.OrderAction.ORDER_TRANSFER_ITEMS]: transferItems_1.default,
    [domain_1.OrderAction.ORDER_TRANSFERRED_ITEMS]: transferredItems_1.default,
    [domain_1.OrderAction.ORDER_TRANSFER_TABLES]: transferTables_1.default,
    [domain_1.OrderAction.ORDER_LOCK]: orderLock_1.default,
    [domain_1.OrderAction.ORDER_UNLOCK]: orderUnlock_1.default,
};
exports.OCCUPIED_TABLE_EVENTS = [
    domain_1.OrderAction.ORDER_ITEM_ADD,
    domain_1.OrderAction.ORDER_ITEM_REMOVE,
    domain_1.OrderAction.ORDER_ADD_VARIANT,
    domain_1.OrderAction.ORDER_ITEM_ADD_MODIFIER,
    domain_1.OrderAction.ORDER_ITEM_REMOVE_MODIFIER,
    domain_1.OrderAction.ORDER_ITEM_UPDATE_MODIFIER_QUANTITY,
    domain_1.OrderAction.ORDER_ITEM_UPDATE_QUANTITY,
    domain_1.OrderAction.ORDER_SAVE,
    domain_1.OrderAction.ORDER_ACCEPT,
    domain_1.OrderAction.ORDER_HOLD,
];
exports.default = eventHandlerMap;
//# sourceMappingURL=index.js.map